import {
  FETCHING_HUB_LAYOUT_REQUEST, FETCHING_HUB_LAYOUT_SUCCEDDED, FETCHING_HUB_LAYOUT_FAILED, INVALIDATE_HUB_LAYOUT,
  FETCHING_HUB_LAYOUTS_REQUEST, FETCHING_HUB_LAYOUTS_SUCCEEDED, FETCHING_HUB_LAYOUTS_FAILED,
  UPDATING_HUB_LAYOUT_REQUEST, UPDATING_HUB_LAYOUT_SUCCEEDED, UPDATING_HUB_LAYOUT_FAILED, 
  REARRANGING_HUB_LAYOUT_SUCCEEDED, DELETING_HUB_ROW_REQUEST, DELETING_HUB_ROW_SUCCEEDED, DELETING_HUB_ROW_FAILED,
  FETCHING_HUB_SECTION_REQUEST, FETCHING_HUB_SECTION_SUCCEDDED, FETCHING_HUB_SECTION_FAILED,
  FETCHING_HUB_STREAMS, FETCHING_HUB_STREAMS_SUCCEDDED, FETCHING_HUB_STREAMS_FAILED, INVALIDATE_HUB_STREAMS,
  FETCHING_RECOMMENDED_STREAMS, FETCHING_RECOMMENDED_STREAMS_SUCCEDDED, INVALIDATE_RECOMMENDED_STREAMS,

  FETCHING_HUB_MOST_VIEWED_ASSETS, FETCHING_HUB_MOST_VIEWED_ASSETS_SUCCEDDED, FETCHING_HUB_MOST_VIEWED_ASSETS_FAILED,
  INVALIDATE_HUB_MOST_VIEWED_ASSETS,

  FETCHING_HUB_RECOMMENDED_ASSETS, FETCHING_HUB_RECOMMENDED_ASSETS_SUCCEDDED, FETCHING_HUB_RECOMMENDED_ASSETS_FAILED,
  INVALIDATE_HUB_RECOMMENDED_ASSETS,

  FETCHING_HUB_RECENT_ASSETS, FETCHING_HUB_RECENT_ASSETS_SUCCEDDED, FETCHING_HUB_RECENT_ASSETS_FAILED,

  SEARCHING_STREAM, SEARCHING_STREAM_SUCCEDDED,
  SEARCHING_ASSET, SEARCHING_ASSET_SUCCEDDED,
  CREATE_STREAM, CREATE_STREAM_SUCCEDDED, CREATE_STREAM_FAILED, INVALIDATE_CREATE_STREAM_ERRORS,
  FETCHING_HUB_RECENTLY_VIEWED_ASSETS, FETCHING_HUB_RECENTLY_VIEWED_ASSETS_SUCCEDDED, FETCHING_HUB_RECENTLY_VIEWED_ASSETS_FAILED,
  INVALIDATE_HUB_RECENTLY_VIEWED_ASSETS, 
  UPDATING_HUB_SECTION_CONTENTS_SUCCEEDED, UPDATING_HUB_SECTION_CONTENTS_FAILED, UPDATE_HUB_SECTION_CONTENTS, 
  UPDATING_HUB_SECTION_REQUEST, UPDATING_HUB_SECTION_SUCCEEDED, UPDATING_HUB_SECTION_FAILED, 
  CREATING_HUB_SECTION_REQUEST, CREATING_HUB_SECTION_SUCCEEDED, CREATING_HUB_SECTION_FAILED,
  ENABLING_ACCESS_FOR_USER_GROUPS, ENABLING_ACCESS_FOR_USER_GROUPS_SUCCEEDED, ENABLING_ACCESS_FOR_USER_GROUPS_FAILED,
  DELETING_HUB_LAYOUT_REQUEST, DELETING_HUB_LAYOUT_SUCCEEDED, DELETING_HUB_LAYOUT_FAILED, RECORD_SEARCH_CLICK, RECORD_SEARCH_CLICK_SUCCEEDED, RECORD_SEARCH_CLICK_FAILED,
  FETCHING_RECOMMENDED_STREAMS_FAILED
} from './actionTypes.jsx';


import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const STREAMS_BASE_URL = `${apiUrl}/api/2.0/streams`;
const PROMOTED_CONTENT_URL = `${apiUrl}/api/2.0/hub/promote-content`
const HUB_STREAMS_URL = `${STREAMS_BASE_URL}/hub`;
const HUB_RECOMMENDED_STREAMS_URL = `${STREAMS_BASE_URL}/recommended`;

const ASSETS_BASE_URL = `${apiUrl}/api/2.0/assets`;

const HUB_LAYOUT_URL = `${apiUrl}/api/2.0/hub/layout`;
const HUB_SECTION_URL = `${apiUrl}/api/2.0/hub/sections`;
const HUB_URL = `${apiUrl}/api/2.1/hub`;
const SEARCH_CLICK = `${apiUrl}/api/2.0/search/click`

/**
* Fetch Hub Layout
*/
export function fetchHubLayout(id) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_LAYOUT_REQUEST));

    let url = buildUrl(HUB_URL, {
      path: `/layout/${id}`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_LAYOUT_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_LAYOUT_FAILED, error))
      )
  }
}

/**
* Fetch All Hub Layouts
*/
export function fetchAllHubLayout(userGroups) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_LAYOUTS_REQUEST));

    let url = buildUrl(HUB_URL, {
      path: `/all`
    });

    return axios({
      method: 'GET',
      url: url,
      params: {
        userGroups: userGroups
      }
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_LAYOUTS_SUCCEEDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_LAYOUTS_FAILED, error))
      )
  }
}

/**
* Update Hub Layout
*/
export function updateHubLayout(layout) {
  return function (dispatch) {
    dispatch(fetchingAction(UPDATING_HUB_LAYOUT_REQUEST));

    let url = buildUrl(HUB_LAYOUT_URL, {
      path: '/update'
    });

    return axios({
      method: 'POST',
      url: url,
      data: layout,
      
    })
      .then(response =>
        dispatch(fetchingSucceededAction(UPDATING_HUB_LAYOUT_SUCCEEDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(UPDATING_HUB_LAYOUT_FAILED, error))
      )
  }
}

/**
* Rearrange Hub Layout
*/
export function rearrangeHubLayout(rowIndex, direction) {
  return function (dispatch) {
    dispatch(fetchingAction(REARRANGING_HUB_LAYOUT_SUCCEEDED, {
      index: rowIndex,
      direction: direction
    }));
  }
}

/**
* Delete Hub Row
*/
export function deleteHubRow(index, layoutId) {
  return function (dispatch) {
    dispatch(fetchingAction(DELETING_HUB_ROW_REQUEST));

    let url = buildUrl(HUB_SECTION_URL, {
      path: '/delete'
    });

    return axios({
      method: 'DELETE',
      url: url,
      params: {
        index: index,
        layoutId: layoutId
      }
    })
      .then(response =>
        dispatch(fetchingSucceededAction(DELETING_HUB_ROW_SUCCEEDED, {
          index: index,
          response: response.data
        }))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(DELETING_HUB_ROW_FAILED, error))
      )
  }
}

export function invalidateHubLayout() {
  return {
    type: INVALIDATE_HUB_LAYOUT,
    payload: {}
  }
}

/**
* Fetch Hub Section by id
*/
export function fetchHubSection(id) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_SECTION_REQUEST, { id: id }));

    let url = buildUrl(HUB_URL, {
      path: `/sections/${id}`
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_SECTION_SUCCEDDED, {
          id: id,
          response: response.data
        }))
      )
      .catch(error => {
        console.log(error);
        return dispatch(fetchingFailedAction(FETCHING_HUB_SECTION_FAILED, {
          id: id,
          error: error
        }))
      })
  }
}

export function invalidateHubSection(id) {
  return {
    type: INVALIDATE_HUB_LAYOUT,
    payload: {}
  }
}

export function shouldFetchHubLayout(state) {
  return shouldFetchResource(state.hub.layout);
}

/**
* Update Hub Section
*/

export function updateHubSection(rowIndex, request, create) {
  return function (dispatch) {
    dispatch(fetchingAction(UPDATING_HUB_SECTION_REQUEST));

    let url = buildUrl(HUB_SECTION_URL, {
      path: '/update'
    });

    return axios({
      method: 'POST',
      url: url,
      data: request
    })
      .then(response =>
        dispatch(updatingHubSectionSucceeded(rowIndex, response.data, create))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(UPDATING_HUB_SECTION_FAILED, error))
      )
  }
}

function updatingHubSectionSucceeded(rowIndex, response, create) {
  return {
    type: UPDATING_HUB_SECTION_SUCCEEDED,
    payload: {
      response: response,
      rowIndex: rowIndex,
      create: create
    }
  }
}

/**
* Update Hub Section
*/

export function createHubSection(rowIndex, row, request) {
  return function (dispatch) {
    dispatch(fetchingAction(CREATING_HUB_SECTION_REQUEST));

    const url = buildUrl(HUB_SECTION_URL, {
      path: '/create'
    });

    return axios({
      method: 'POST',
      url: url,
      data: request
    })
      .then(response =>
        dispatch(creatingHubSectionSucceeded(rowIndex, row, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(CREATING_HUB_SECTION_FAILED, error))
      )
  }
}

function creatingHubSectionSucceeded(rowIndex, row, response) {
  return {
    type: CREATING_HUB_SECTION_SUCCEEDED,
    payload: {
      response: response,
      row: row,
      rowIndex: rowIndex
    }
  }
}


/**
* Enable Layout Access For User Groups
*/

export function enableLayoutAccessForUserGroups(layoutId, userGroups){
  return function (dispatch) {
    dispatch(fetchingAction(ENABLING_ACCESS_FOR_USER_GROUPS))

    let url = buildUrl(HUB_URL, {
      path: `/layout/${layoutId}/access`
    });

    return axios({
      method: "POST",
      url: url,
      data: userGroups
    })
    .then(response =>
      dispatch(fetchingSucceededAction(ENABLING_ACCESS_FOR_USER_GROUPS_SUCCEEDED, response.data))
    )
      .catch(error =>
        dispatch(fetchingFailedAction(ENABLING_ACCESS_FOR_USER_GROUPS_FAILED, error))
      )
  }
}

/**
* deleting hub layout
*/
export function deleteHubLayout(layoutId) {
  return function (dispatch) {
    dispatch(fetchingAction(DELETING_HUB_LAYOUT_REQUEST));

    let url = buildUrl(HUB_LAYOUT_URL, {
      path: '/delete'
    });

    return axios({
      method: 'DELETE',
      url: url,
      params: {
        layoutId: layoutId
      }
    })
      .then(response =>
        dispatch(fetchingSucceededAction(DELETING_HUB_LAYOUT_SUCCEEDED, layoutId))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(DELETING_HUB_LAYOUT_FAILED, error))
      )
  }
}


/**
* Fetch Hub Streams
*/
export function fetchHubStreams() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_STREAMS));

    return axios({
      method: 'GET',
      url: HUB_STREAMS_URL
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_STREAMS_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_STREAMS_FAILED, error))
      )
  }
}

export function invalidateHubStreams() {
  return {
    type: INVALIDATE_HUB_STREAMS,
    payload: {}
  }
}

export function shouldFetchHubStreams(state) {
  return shouldFetchResource(state.hub.streams);
}

/**
* Fetch recommended streams
*/
export function fetchRecommendedStreams() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_RECOMMENDED_STREAMS));

    return axios({
      method: 'GET',
      url: HUB_RECOMMENDED_STREAMS_URL
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_RECOMMENDED_STREAMS_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_RECOMMENDED_STREAMS_FAILED, error))
      )
  }
}

export function invalidateRecommendedStreams() {
  return {
    type: INVALIDATE_RECOMMENDED_STREAMS,
    payload: {}
  }
}

export function shouldFetchRecommendedStreams(state) {
  return shouldFetchResource(state.hub.recommendedStreams);
}

/**
* Fetch Most Viewed Assets
*/
export function fetchHubMostViewedAssets() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_MOST_VIEWED_ASSETS));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: 'highest-viewed'
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_MOST_VIEWED_ASSETS_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_MOST_VIEWED_ASSETS_FAILED, error))
      )
  }
}

export function invalidateHubMostViewedAssets() {
  return {
    type: INVALIDATE_HUB_MOST_VIEWED_ASSETS,
    payload: {}
  }
}

export function shouldFetchHubMostViewedAssets(state) {
  return shouldFetchResource(state.hub.assets.mostViewed);
}

/**
* Fetch Recently Viewed Assets
*/
export function fetchHubRecentlyViewedAssets() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_RECENTLY_VIEWED_ASSETS));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: 'recently-viewed'
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_RECENTLY_VIEWED_ASSETS_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_RECENTLY_VIEWED_ASSETS_FAILED, error))
      )
  }
}

export function invalidateHubRecentlyViewedAssets() {
  return {
    type: INVALIDATE_HUB_RECENTLY_VIEWED_ASSETS,
    payload: {}
  }
}

export function shouldFetchHubRecentlyViewedAssets(state) {
  return shouldFetchResource(state.hub.assets.recentlyViewed);
}



/**
* Fetch Recommended Assets
*/
export function fetchHubRecommendedAssets() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_RECOMMENDED_ASSETS));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: 'recommended'
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_RECOMMENDED_ASSETS_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_RECOMMENDED_ASSETS_FAILED, error))
      )
  }
}

export function invalidateHubRecommendedAssets() {
  return {
    type: INVALIDATE_HUB_RECOMMENDED_ASSETS,
    payload: {}
  }
}

export function shouldFetchHubRecommendedAssets(state) {
  return shouldFetchResource(state.hub.assets.recommended);
}

/**
* Fetch Most Viewed Assets
*/
export function fetchHubRecentAssets() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_RECENT_ASSETS));

    let url = buildUrl(ASSETS_BASE_URL, {
      path: 'last-modified'
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_RECENT_ASSETS_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_RECENT_ASSETS_FAILED, error))
      )
  }
}

// export function invalidateHubRecentAssets() {
//   return {
//     type: INVALIDATE_HUB_ASSETS,
//     payload: {}
//   }
// }

export function shouldFetchHubRecentAssets(state) {
  return shouldFetchResource(state.hub.assets.recent);
}

/*
* Common functions
*/
function fetchingAction(type, json) {
  return {
    type: type,
    payload: json
  }
}

function fetchingSucceededAction(type, json) {
  return {
    type: type,
    payload: json
  }
}

function fetchingFailedAction(type, error) {
  return {
    type: type,
    payload: error
  }
}

export function shouldFetchResource(resource) {
  if (!resource) {
    return true
  } else if (resource.loading) {
    return false
  } else {
    return resource.invalidated
  }
}


/*
* Search Streams
*/

export function searchStream(query) {
  return function (dispatch) {
    dispatch(searchingStream());

    let url = buildUrl(STREAMS_BASE_URL, {
      path: '/search'
    });

    let param = {
      query: query
    }

    return axios({
      method: 'GET',
      url: url,
      param: param
    })
      .then(response => {
        return dispatch(searchingStreamSuccedded(response.data))
      })
      .catch(error => {
        return dispatch(searchingStreamFailed())
      })
  }
}

function searchingStream() {
  return {
    type: SEARCHING_STREAM,
    payload: {}
  }
}

function searchingStreamSuccedded(response) {
  return {
    type: SEARCHING_STREAM_SUCCEDDED,
    payload: response
  }
}

function searchingStreamFailed() {
  return {
    type: SEARCHING_STREAM_SUCCEDDED,
    payload: {}
  }
}


/*
* Search Asset
*/

export function searchAsset(query) {
  return function (dispatch) {
    dispatch(searchingAsset());

    let url = buildUrl(ASSETS_BASE_URL, {
      path: '/search'
    });

    let param = {
      query: query
    }

    return axios({
      method: 'GET',
      url: url,
      param: param
    })
      .then(response => {
        return dispatch(searchingAssetSuccedded(response.data))
      })
      .catch(error => {
        return dispatch(searchingAssetFailed())
      })
  }
}

function searchingAsset() {
  return {
    type: SEARCHING_ASSET,
    payload: {}
  }
}

function searchingAssetSuccedded(response) {
  return {
    type: SEARCHING_ASSET_SUCCEDDED,
    payload: response
  }
}

function searchingAssetFailed() {
  return {
    type: SEARCHING_ASSET_SUCCEDDED,
    payload: {}
  }
}

/*
* CREATE STREAM
*/

export function createStream(stream) {
  return function (dispatch) {
    dispatch(creatingStream());

    return axios({
      method: 'POST',
      url: STREAMS_BASE_URL,
      data: stream
    })
      .then(response => {
        return dispatch(creatingStreamSuccedded(response.data))
      })
      .catch(error => {
        //return dispatch(creatingStreamFailed(error.response.data.errors.fieldErrors))
      })
  }
}

export function invalidateStreamCreationError() {
  return {
    type: INVALIDATE_CREATE_STREAM_ERRORS,
    payload: {}
  }
}

function creatingStream() {
  return {
    type: CREATE_STREAM,
    payload: {}
  }
}

function creatingStreamSuccedded(response) {
  return {
    type: CREATE_STREAM_SUCCEDDED,
    payload: response
  }
}

function creatingStreamFailed(error) {
  return {
    type: CREATE_STREAM_FAILED,
    payload: error
  }
}


export function toggleEditHubSection() {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_HUB_LAYOUT_REQUEST));

    return axios({
      method: 'POST',
      url: HUB_LAYOUT_URL
    })
      .then(response =>
        dispatch(fetchingSucceededAction(FETCHING_HUB_LAYOUT_SUCCEDDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(FETCHING_HUB_LAYOUT_FAILED, error))
      )
  }
}

export function updateHubSectionContents(sectionId, contents) {
  return function (dispatch) {
    dispatch(updatingHubSectionContent(sectionId, contents));
    const url = buildUrl(HUB_SECTION_URL, {
      path: `${sectionId}/contents`
    });

    return axios({
      method: 'POST',
      url: url,
      data: {
        contents: contents
      }
    })
      .then(response => {
        dispatch(updatingHubSectionContentSuccedded(sectionId, response.data))
      })
      .catch(error =>
        dispatch(updatingHubSectionContentFailed(error))
      )
  }
}

export function recordSearchClick(id, type) {

  return function (dispatch) {
    dispatch(fetchingAction(RECORD_SEARCH_CLICK));

    let url = buildUrl(SEARCH_CLICK);

    const body = {
      entityId: id,
      entityType: type
    }

    return axios({
      method: 'POST',
      url: url,
      data: body
    })
      .then(response =>
        dispatch(fetchingSucceededAction(RECORD_SEARCH_CLICK_SUCCEEDED, response.data))
      )
      .catch(error =>
        dispatch(fetchingFailedAction(RECORD_SEARCH_CLICK_FAILED, error))
      )
  }
}

function updatingHubSectionContent(sectionId, contents) {
  return {
    type: UPDATE_HUB_SECTION_CONTENTS,
    payload: {
      sectionId,
      contents
    }
  }
}

function updatingHubSectionContentSuccedded(sectionId, contents) {
  return {
    type: UPDATING_HUB_SECTION_CONTENTS_SUCCEEDED,
    payload: {
      sectionId,
      contents
    }
  }
}

function updatingHubSectionContentFailed(error) {
  return {
    type: UPDATING_HUB_SECTION_CONTENTS_FAILED,
    payload: error
  }
}
